"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VOLTAGE_RANK_COUNT = void 0;
exports.parseVoltage = parseVoltage;
exports.computeVoltageScale = computeVoltageScale;
exports.voltageRankForLabel = voltageRankForLabel;
exports.VOLTAGE_RANK_COUNT = 7;
function parseVoltage(label) {
    let max = null;
    for (const m of label.matchAll(/(\d+(?:\.\d+)?)\s*V\b/gi)) {
        const v = parseFloat(m[1]);
        if (max === null || v > max) {
            max = v;
        }
    }
    for (const m of label.matchAll(/\b[PN]?(\d+)V(\d+)\b/g)) {
        const v = parseFloat(`${m[1]}.${m[2]}`);
        if (max === null || v > max) {
            max = v;
        }
    }
    return max;
}
function computeVoltageScale(fullVariantEdges) {
    const volts = new Set();
    for (const e of fullVariantEdges) {
        if (e.kind !== 'rail') {
            continue;
        }
        const v = parseVoltage(e.label);
        if (v !== null) {
            volts.add(v);
        }
    }
    const sorted = [...volts].sort((a, b) => b - a);
    const n = sorted.length;
    return sorted.map((voltage, i) => ({
        voltage,
        rank: n === 1 ? 0 : Math.round((i * (exports.VOLTAGE_RANK_COUNT - 1)) / (n - 1)),
        label: `${voltage}V`,
    }));
}
function voltageRankForLabel(scale, label) {
    const v = parseVoltage(label);
    if (v === null) {
        return null;
    }
    const entry = scale.find((s) => s.voltage === v);
    return entry ? entry.rank : null;
}
//# sourceMappingURL=voltage.js.map